<script>
export default {
    inject: ['levelSelect'],
    props: {
        data: {
            required: true
        },
        isView: {
            type: Boolean,
            default: false
        }
    },
    render(h) {
        const {renderViewNode, renderNode} = this.levelSelect;
        if (this.isView && renderViewNode) {
            return <span class="label">{renderViewNode(h, this.data)}</span>;
        }
        if (renderNode) {
            return <span class="label">{renderNode(h, this.data)}</span>;
        }
        return <span class="label">{this.data.label}</span>;
    }
};
</script>
<style lang="scss" scoped>
</style>
